import { render, staticRenderFns } from "./TicketsInfoPets.vue?vue&type=template&id=3188aeda&scoped=true&lang=pug&"
import script from "./TicketsInfoPets.vue?vue&type=script&lang=js&"
export * from "./TicketsInfoPets.vue?vue&type=script&lang=js&"
import style0 from "./TicketsInfoPets.vue?vue&type=style&index=0&id=3188aeda&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3188aeda",
  null
  
)

export default component.exports